export const AINEXT_SET_USER = 'AINEXT_SET_USER';
export const AINEXT_RESET = 'AINEXT_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
